import React, { CSSProperties } from 'react'
import { CheckboxProps } from './Checkbox.types'
import styles from './Checkbox.module.scss'
import cl from 'classnames'

const CheckboxComponent = (props: CheckboxProps) => {
  const {
    isChecked,
    onClick,
    className,
    style,
    fillColor
  } = props

  const fillColorStyle: CSSProperties = fillColor && isChecked
    ? {
      borderColor: fillColor,
      backgroundColor: fillColor
    }
    : {}

  return (
    <div
      className={cl(styles.container, {
        [styles.checked]: isChecked,
        [styles.clickable]: onClick
      }, className)}
      style={{
        ...style,
        ...fillColorStyle
      }}
      onClick={onClick}
    >
      {isChecked && (
        <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'>
          <g>
            <path d='M3.448,6.775,1.135,4.462a.665.665,0,0,0-.94.94L2.982,8.188a.664.664,0,0,0,.94,0l7.053-7.053a.665.665,0,0,0-.94-.94Z' transform='translate(2.552 4.005)' fill='#fff' />
          </g>
        </svg>
      )}
    </div>
  )
}

const Checkbox = CheckboxComponent
export { Checkbox }
